import React, { Component } from 'react'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts'
import Checkbox from './Checkbox';
import '../styles/graph.css'

const items = [
  'blocked',
  'received'
]

const yearOrg = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sept', 'Oct', 'Nov', 'Dec']

class SimpleAreaChart extends Component {
  state = {
    interval: 'month',
    intervalLen: 12,
    status: ['blocked', 'received'],
    data: this.setData(this.props.history, 'month', 12, ['blocked', 'received'], yearOrg)
  }

  toggleCheckbox = label => {
    let tog = false
    let arr = this.state.status
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === label && i === 0) {
        tog = true
        arr.shift()
        this.setState({ status: arr })
      } else if (arr[i] === label && i === 1) {
        tog = true
        arr.pop()
        this.setState({ status: arr })
      }
    }
    if (tog === false) {
      arr.push(label)
      this.setState({ status: arr })
    }
    this.setState({ data: this.setData(this.props.history, this.state.interval, this.state.intervalLen, this.state.status, yearOrg) })
  }

  createCheckbox = label => (
    <Checkbox class='checkbox'
            label={label}
            handleCheckboxChange={this.toggleCheckbox}
            key={label}
        />
  )

  createCheckboxes = () => (
    items.map(this.createCheckbox)
  )

  setInterval () {
    this.setState({ interval: 'month' })
  }

  setData (history, interval, intervalLen, options, yearOrg) {
    let tmpArr = parseInt((new Date(Date.now())).toLocaleDateString("en-UK").substr(3, 2))
    let year = yearOrg.slice(tmpArr).concat(yearOrg.slice(0, tmpArr))
    let values = []
    for (let i = 0; i < intervalLen; i++) {
      values.push(0)
    }
    let arr = []
    if (interval === 'month') {
      history.forEach(elem => {
        for (let i = 0; i < options.length; i++) {
          if (elem.status === options[i]) {
            let sub = new Date(Date.now() - elem.time)
            if (sub.getFullYear() >= 1971 && sub.getMonth() > 8) {
            } else {
              let date = new Date(elem.time)
              values[parseInt(date.toLocaleDateString("en-UK").substr(3, 2)) - 1] += 1
            }
          }
        }
      })
      for (let i = 0; i < intervalLen; i++) {
        arr.push({month: year[i], calls: values[i]})
      }
    }else if (interval === 'lifetime') {
      history.sort((a, b) => {return a.time - b.time}).forEach(elem => {
        for (let i = 0; i < options.length; i++) {
          if (elem.status === options[i]) {
            let date = new Date(elem.time)
            values[parseInt(date.toLocaleDateString("en-UK").substr(3, 2)) - 1] += 1
          }
        }
      })
      for (let i = 0; i < intervalLen; i++) {
        arr.push({month: year[i], calls: values[i]})
      }
    }
    return arr
  }

  render () {
   return (
    <div className='chart-wrapper'>
      {this.createCheckboxes()}
      <AreaChart class='chart'
        width={window.innerWidth * 0.8}
        height={window.innerHeight * 0.7}
        data={this.state.data}
        margin={{ top: window.innerHeight * 0.1, left: window.innerWidth * 0.1 }}
      >
        <CartesianGrid strokeDasharray="2 2" />
        <XAxis dataKey={this.state.interval} fontSize='15' />
        <YAxis fontSize='20' />
        <Tooltip />
        <Area
          type='monotone'
          dataKey='calls'
          stroke='#8884d8'
          fill='#8884d8'
        />
      </AreaChart>
    </div>
    );
  }
}

export default SimpleAreaChart;